import { useEffect } from "react";
import _ from "lodash";

let loadCount = 1;
const decrement = () => {
    loadCount = loadCount - 1;
    if(loadCount === 0) {
        document.getElementById("main-loader").style = "display: none";
    }
};

const increment = () => {
    loadCount = loadCount + 1;
    if(loadCount === 1) {
        document.getElementById("main-loader").style = "display: block";
    }
};

export const removeMainLoader = _.once((ignoreTimer) => {
    const now = (new Date()).valueOf();
    const then = window.__loadStart;

    const diff = now - then;
    if(diff < 1400 && !ignoreTimer){
        setTimeout(() => {
            decrement();
        }, 1400 - diff)
    } else {
        decrement();
    }

});

export default () => {
    useEffect(() => {
        increment();

        return decrement;
    }, []);

    return ""
};